import WidgetClassListResourcePagingResultModel from '../../generated/types/model/resource/WidgetClassListResourcePagingResultModel';

export default class WidgetClassListResourcePagingResultViewModel extends WidgetClassListResourcePagingResultModel {
  protected transformToDTO() {}
  protected transformFromDTO() {}
}
